module.exports = __webpack_public_path__ + "img/prepare-lesson-delete.9e99d79a.svg";